"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import {
  ArrowLeftRight,
  Building2,
  Home,
  Inbox,
  PlayCircle,
  Settings,
  Shield,
} from "lucide-react";

const ITENS_PROGRAMADOR = [
  { href: "/programador/inicio", label: "Início", Icon: Home },
  { href: "/programador", label: "Empresas", Icon: Building2 },
  { href: "/programador/aulas", label: "Aulas", Icon: PlayCircle },
  { href: "/migracao", label: "Migrações", Icon: ArrowLeftRight },
  { href: "/solicitacoes", label: "Solicitações", Icon: Inbox },
  { href: "/configuracoes", label: "Configurações", Icon: Settings },
];

const DICAS = [
  "Base limpa reduz retrabalho na operacao.",
  "Alteracoes sensiveis precisam manter o fluxo simples e rastreavel.",
  "Boa manutencao protege a rotina de quem usa o sistema todos os dias.",
  "Antes de liberar acesso, confira se a conta esta no perfil correto.",
  "Um ajuste pequeno no lugar certo evita suporte desnecessario depois.",
  "Operacao estavel nasce de tela clara, regra preservada e acao objetiva.",
];

function dicaInicial() {
  const dia = new Intl.DateTimeFormat("pt-BR", {
    timeZone: "America/Sao_Paulo",
    day: "numeric",
  }).format(new Date());

  return DICAS[(Number(dia) || 1) % DICAS.length];
}

export function ProgramadorDesktopSidebar({ pathname, integrado = false }: { pathname: string; integrado?: boolean }) {
  const [dicaAtual, setDicaAtual] = useState(dicaInicial);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setDicaAtual((atual) => {
        const indice = Math.max(0, DICAS.indexOf(atual));
        return DICAS[(indice + 1) % DICAS.length];
      });
    }, 30000);

    return () => window.clearInterval(timer);
  }, []);

  const itemAtivo = (href: string) => (href === "/programador" ? pathname === href : pathname === href || pathname.startsWith(href + "/"));

  return (
    <aside className={`hidden lg:block lg:flex-shrink-0 ${integrado ? "lg:w-[185px]" : "lg:w-[203px]"}`}>
      <div
        data-admin-desktop-sidebar="true"
        className={`sticky flex flex-col bg-[var(--surface-sidebar)] px-4 py-5 ${integrado ? "top-0 h-dvh border-0 shadow-none" : "top-8 h-[calc(100dvh-4rem)] rounded-[24px] border border-[var(--border)] shadow-[var(--shadow-soft)]"}`}
      >
        <div>
          <div className={`flex items-center gap-2 pb-4 ${integrado ? "" : "border-b border-[var(--border-subtle)]"}`}>
            <div data-admin-desktop-brand="true" className="flex h-11 w-11 items-center justify-center rounded-[14px] text-sm font-bold text-white">
              BP
            </div>
            <div className="min-w-0">
              <p className="truncate text-[13px] font-semibold text-[var(--text-primary)]">Acompanhamento</p>
              <p className="text-[11px] text-[var(--text-soft)]">Admin da plataforma</p>
            </div>
          </div>

          <nav className="mt-5 space-y-2">
            {ITENS_PROGRAMADOR.map(({ href, label, Icon }) => (
              <Link
                key={href}
                href={href}
                prefetch
                className={`flex h-9 w-full items-center gap-2 rounded-[12px] px-2.5 text-[12.5px] font-medium transition-colors ${
                  itemAtivo(href) ? "bg-[var(--surface-active)] text-[var(--text-primary)]" : "text-[var(--text-secondary)] hover:bg-[var(--surface-card-2)]"
                }`}
              >
                <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-[9px] bg-[var(--surface-card-2)]">
                  <Icon className="h-4 w-4" />
                </span>
                <span className="min-w-0 truncate">{label}</span>
              </Link>
            ))}
          </nav>
        </div>

        <div className="mt-auto space-y-4">
          <div className="rounded-[18px] border border-[var(--border)] bg-[var(--surface-card-2)] px-3 py-4 text-center">
            <div data-admin-desktop-tip-icon="true" className="mx-auto flex h-8 w-8 items-center justify-center rounded-[10px]">
              <Shield className="h-4 w-4" />
            </div>
            <p className="mt-2.5 text-[14px] font-semibold leading-tight text-[var(--text-primary)]">Dica Bem Protege</p>
            <p className="mt-2 line-clamp-4 text-[11px] leading-5 text-[var(--text-secondary)]">{dicaAtual}</p>
          </div>
        </div>
      </div>
    </aside>
  );
}
